export default {
  accountsReceivable: undefined,
  client: undefined,
};
